import WidgetContainer from './Widget';

export default WidgetContainer;
